import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import Address from './Address'
import DefaultAddresses from './DefaultAddresses'

const AddressBook = ({ addresses, className, onDeleteCustomerAddress }) => (
  <div className={className}>
    <DefaultAddresses addresses={addresses} />
    {addresses
      .filter((address) => !address.default_shipping && !address.default_billing)
      .map((address) => (
        <Address
          address={address}
          key={address.id}
          onDeleteCustomerAddress={onDeleteCustomerAddress}
        />
      ))}
  </div>
)

AddressBook.defaultProps = {
  className: '',
}

AddressBook.propTypes = {
  addresses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
    }),
  ).isRequired,
  className: PropTypes.string,
  onDeleteCustomerAddress: PropTypes.func.isRequired,
}

const StyledAddressBook = styled(AddressBook)({
  display: 'grid',
  columnGap: '25px',
  gridTemplateColumns: '1fr',
  '@media(min-width: 600px)': {
    gridTemplateColumns: '1fr 1fr',
  },
  '@media(min-width: 1200px)': {
    gridTemplateColumns: '1fr 1fr 1fr',
  },
})

export default StyledAddressBook
